const Tag = ({ type, text }) => (
  <span className={ `tag is__${ type }` }>{ text }</span>
)

export default Tag
